import React, { useState, useRef, useEffect } from 'react';
import PropTypes from 'prop-types';

function BottomSheet({
  // eslint-disable-next-line react/prop-types
  isOpen, onClose, title, children, clearFilter, applyFilters, pageName, initialHeight,
}) {
  const [height, setHeight] = useState(initialHeight); // Initial height of the bottom sheet
  const sheetRef = useRef();
  useEffect(() => {
    // console.log('hello init ', height)
  }, [height]);
  // const handleTouchEvent = (event) => {
  //   if (event.type === "touchmove") {
  //     const screenHeight = window.innerHeight;
  //     const touchY = event.touches[0].clientY;
  //     const newHeight = ((screenHeight - touchY) / screenHeight) * 100;

  //     // Restrict height between 30% and 70%
  //     if (newHeight > 70) {
  //       setHeight(`100%`);
  //     } else if (newHeight >= 30 && newHeight <= 70) {
  //       setHeight(`${newHeight}%`);
  //     }
  //   }
  //   else if (event.type === "touchend") {
  //     // Snap to either 30% or 70% based on current height
  //     const currentHeight = parseFloat(height);
  //     if (currentHeight > 70) {
  //       setHeight(`100%`);
  //     } else if (currentHeight >= 35 && currentHeight <= 70) {
  //       setHeight(initialHeight);
  //     }
  //     else {
  //       // console.log('less than 30')
  //       setHeight("0%");
  //       onClose();
  //     }
  //   }
  // };
  let isTouchMoving = false;

  const handleTouchEvent = (event) => {
    // console.log('in tt event type', event.type);

    if (event.type === 'touchstart') {
      isTouchMoving = false; // Reset on touch start
    }

    if (event.type === 'touchmove') {
      isTouchMoving = true; // Set flag on movement

      const screenHeight = window.innerHeight;
      const touchY = event.touches[0].clientY;
      const newHeight = ((screenHeight - touchY) / screenHeight) * 100;

      console.log('touch event ', newHeight, screenHeight);

      if (newHeight > 70) {
        setHeight('100%');
      } else if (newHeight >= 30 && newHeight <= 70) {
        setHeight(`${newHeight}%`);
      }
    } else if (event.type === 'touchend') {
      if (!isTouchMoving) {
        // console.log("Ignoring touchend because no movement detected");
        return; // Ignore touchend if no move happened
      }

      const currentHeight = parseFloat(height);

      if (currentHeight > 70) {
        setHeight('100%');
      } else if (currentHeight >= 35 && currentHeight <= 70) {
        setHeight(initialHeight);
      } else {
        setHeight('0%');
        onClose();
      }
    }
  };

  return (
    <div
      className={`fixed inset-0 z-50 transition-all ${isOpen ? 'pointer-events-auto' : 'pointer-events-none'
      } lg:hidden `}
    >
      {/* Overlay */}
      <div
        className={`fixed inset-0 bg-black bg-opacity-50 transition-opacity ${isOpen ? 'opacity-100' : 'opacity-0'
        }`}
        onClick={onClose}
        aria-hidden="true"
      />

      {/* Bottom Sheet */}
      <div
        ref={sheetRef}
        className="absolute bottom-0 left-0 right-0 bg-white rounded-t-lg shadow-lg overflow-hidden flex flex-col transform transition-transform"
        style={{ height }}
        onTouchMove={handleTouchEvent}
        onTouchEnd={handleTouchEvent}
      >
        {/* Drag Handle */}
        <div className="w-12 h-1.5 bg-gray-300 rounded-full mx-auto mt-2 cursor-pointer" />

        {/* Title */}
        <div className={`${pageName === 'study plan' ? 'border-none' : 'border-b'} p-4 flex justify-between items-center'`} style={{ borderColor: '#939393' }}>
          <h2 className="2xl:text-lg xl:text-base md:text-base text-base font-semibold text-gray-800">{title}</h2>
        </div>

        {/* Content */}
        <div className="flex-1 overflow-y-auto">{children}</div>
        <div className={`${pageName === 'study plan' ? 'border-none' : 'border-t'} p-4 border-t border-gray-200 flex justify-between md:justify-center items-center'`} style={{ borderColor: '#939393' }}>
          {pageName !== 'study plan'
          && (
          <div className="flex sm:justify-end md:justify-center space-x-4 w-full md:w-[70%]">
            <button type="button" className="bg-white-500 border border-gray-500 text-gray-500 font-medium px-4 py-2 rounded-md hover:bg-gray-100 hover:border-gray-600 focus:outline-none focus:ring-2 focus:ring-gray-400 w-full" onClick={clearFilter}>
              Clear Filters
            </button>
            <button type="button" className="bg-tabBlue text-white px-4 py-4 rounded-md font-medium hover:bg-tabBlue-600 focus:outline-none focus:ring-2 focus:ring-blue-400 w-full" onClick={applyFilters}>
              Apply
            </button>
          </div>
          )}
        </div>
      </div>
    </div>
  );
}

BottomSheet.propTypes = {
  isOpen: PropTypes.bool.isRequired,
  onClose: PropTypes.func.isRequired,
  title: PropTypes.string.isRequired,
  // Children: PropTypes.object.isRequired,
  clearFilter: PropTypes.func.isRequired,
  applyFilters: PropTypes.func.isRequired,
};
export default BottomSheet;
